import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';

import { useAppSelector } from '../../../store/hooks';
import { PortalTechnicianDataSelector } from '../../../store/config/selectors';

import Button from '../../Button/Button';

import { technicianDataFields } from '../constants';
import useStyles from '../styles';

interface IProps {
  open: boolean;
  onClose: () => void;
}

const TechnicianDataDialog: React.FC<IProps> = ({ open, onClose }) => {
  const classes = useStyles();
  const techData = useAppSelector(PortalTechnicianDataSelector);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Technician Data</DialogTitle>
      <DialogContent>
        {technicianDataFields.map(
          i =>
            techData[i.name] && (
              <div key={i.name} className={classes.technicianDataField}>
                <b>{i.label}:</b>
                <p>{techData[i.name]}</p>
              </div>
            ),
        )}
      </DialogContent>
      <DialogActions>
        <Button text="Close" onClick={onClose} />
      </DialogActions>
    </Dialog>
  );
};

export default TechnicianDataDialog;
